import React from 'react';
import PropTypes from 'prop-types';
import { Text } from '../../../../Text';

/* eslint-disable react/display-name */
const HelpText = /*#__PURE__*/React.memo(props => {
  const {
    helpText,
    id
  } = props;
  return helpText ? /*#__PURE__*/React.createElement(Text, {
    size: "sm",
    tag: "p",
    color: "var(--sib-color_content-secondary)",
    id: `${id}-helpText`,
    style: {
      marginBottom: '4px'
    }
  }, helpText) : null;
});
HelpText.propTypes = {
  helpText: PropTypes.string,
  id: PropTypes.string
};
export default HelpText;